module.exports = __webpack_public_path__ + "static/splash-977505ab6069b376d89bd8d0246dc8b0.png";